export default __webpack_public_path__ + "static/media/deleteIcon_drawer.48aa3bbc.svg";